import { render, staticRenderFns } from "./AddAdvances.vue?vue&type=template&id=7d95e342&scoped=true"
import script from "./AddAdvances.vue?vue&type=script&lang=js"
export * from "./AddAdvances.vue?vue&type=script&lang=js"
import style0 from "./AddAdvances.vue?vue&type=style&index=0&id=7d95e342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d95e342",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/AddAdvances.vue
// module id = 2351
// module chunks = 31